'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

var _textarea = require('components/field/textarea');

var _textarea2 = _interopRequireDefault(_textarea);

var _text = require('components/field/text');

var _text2 = _interopRequireDefault(_text);

var _modal = require('modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocationList = new Promise(function (resolve) {
	var xhr = new XMLHttpRequest();
	xhr.open('GET', 'data/locations', true);
	xhr.onreadystatechange = function () {
		if (xhr.readyState == 4) resolve(JSON.parse(xhr.responseText));
	};
	xhr.send();
});

function GetLocationList() {
	return LocationList;
}

var ModalPage = function ModalPage(props) {
	return _react2.default.createElement(
		'div',
		{ className: 'feedback-modal-page' },
		props.children
	);
};
var Title = function Title(props) {
	return _react2.default.createElement(
		'p',
		{ className: 'feedback-title' },
		props.children
	);
};
var Header = function Header(props) {
	return _react2.default.createElement(
		'h1',
		null,
		props.children
	);
};
var Text = function Text(props) {
	return _react2.default.createElement(
		'p',
		null,
		props.children
	);
};
var Buttons = function Buttons(props) {
	return _react2.default.createElement(
		'div',
		{ className: _classList2.default.join("button-list", props.className) },
		props.children
	);
};
var Button = function Button(props) {
	return _react2.default.createElement(
		'button',
		{ className: _classList2.default.join("btn", props.className), onClick: props.onClick },
		props.children
	);
};

var FeedbackPagePositive1 = function (_Component) {
	_inherits(FeedbackPagePositive1, _Component);

	function FeedbackPagePositive1(props) {
		_classCallCheck(this, FeedbackPagePositive1);

		var _this = _possibleConstructorReturn(this, (FeedbackPagePositive1.__proto__ || Object.getPrototypeOf(FeedbackPagePositive1)).call(this, props));

		_this.state = { locations: null };
		return _this;
	}

	_createClass(FeedbackPagePositive1, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			GetLocationList().then(function (data) {
				_this2.setState({ locations: data });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				ModalPage,
				null,
				_react2.default.createElement(
					Title,
					null,
					'Feedback'
				),
				_react2.default.createElement(
					Header,
					null,
					'We are glad to hear it!'
				),
				_react2.default.createElement(
					Text,
					null,
					'Select a location below to post your review:'
				),
				_react2.default.createElement(
					Buttons,
					null,
					(this.state.locations || []).map(function (location) {
						return _react2.default.createElement(
							Button,
							{ key: location.id, onClick: function onClick() {
									return _this3.props.setLocation(location);
								} },
							location.name
						);
					})
				)
			);
		}
	}], [{
		key: 'canGoToNextPage',
		value: function canGoToNextPage(props) {
			return !!props.location;
		}
	}]);

	return FeedbackPagePositive1;
}(_react.Component);

var FeedbackPagePositive2 = function (_Component2) {
	_inherits(FeedbackPagePositive2, _Component2);

	function FeedbackPagePositive2() {
		_classCallCheck(this, FeedbackPagePositive2);

		return _possibleConstructorReturn(this, (FeedbackPagePositive2.__proto__ || Object.getPrototypeOf(FeedbackPagePositive2)).apply(this, arguments));
	}

	_createClass(FeedbackPagePositive2, [{
		key: 'render',
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				ModalPage,
				null,
				_react2.default.createElement(
					Title,
					null,
					'Feedback'
				),
				_react2.default.createElement(
					Header,
					null,
					'Now select a review site for ',
					this.props.location.name
				),
				_react2.default.createElement(
					Buttons,
					{ className: 'social-list' },
					Object.keys(this.types).map(function (typeId) {
						return _this5.props.location[typeId] ? _react2.default.createElement(
							Button,
							{ className: 'btn-social btn-social-' + typeId, key: typeId, onClick: function onClick() {
									return _this5.selectType(typeId);
								} },
							_this5.types[typeId]
						) : null;
					})
				)
			);
		}
	}, {
		key: 'selectType',
		value: function selectType(type) {
			window.open(this.props.location[type], "_blank");
			// this.props.close();
		}
	}, {
		key: 'types',
		get: function get() {
			return {
				facebook: 'Facebook',
				twitter: 'Twitter',
				yelp: 'Yelp',
				google: 'Google+'
			};
		}
	}], [{
		key: 'canGoToNextPage',
		value: function canGoToNextPage(props) {
			return false;
		}
	}]);

	return FeedbackPagePositive2;
}(_react.Component);

var IdGenerator = function () {
	var ID = 1;
	return function () {
		return 'generated_' + ID++;
	};
}();

var SelectBox = function (_Component3) {
	_inherits(SelectBox, _Component3);

	function SelectBox(props) {
		_classCallCheck(this, SelectBox);

		var _this6 = _possibleConstructorReturn(this, (SelectBox.__proto__ || Object.getPrototypeOf(SelectBox)).call(this, props));

		_this6.state = { id: IdGenerator() };
		return _this6;
	}

	_createClass(SelectBox, [{
		key: 'render',
		value: function render() {
			var _this7 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'label',
					{ htmlFor: this.state.id },
					this.props.title
				),
				_react2.default.createElement(
					'select',
					{ id: this.state.id, className: 'form-control', placeholder: this.props.placeholder,
						value: this.props.value ? this.props.value.id : "",
						onChange: function onChange(event) {
							return _this7.props.setValue(_this7.props.options.filter(function (item) {
								return item.id == event.target.value;
							})[0]);
						}
					},
					_react2.default.createElement(
						'option',
						{ value: '' },
						this.props.placeholder
					),
					(this.props.options || []).map(function (option) {
						return _react2.default.createElement(
							'option',
							{ key: option.id, value: option.id },
							option.name
						);
					})
				)
			);
		}
	}]);

	return SelectBox;
}(_react.Component);

var Checkbox = function Checkbox(props) {
	return _react2.default.createElement(
		'div',
		{ className: 'checkbox' },
		_react2.default.createElement(
			'label',
			null,
			_react2.default.createElement('input', { type: 'checkbox', checked: props.value, onChange: function onChange(event) {
					return props.setValue(event.target.checked);
				} }),
			props.label
		)
	);
};

var FeedbackPageNegative1 = function (_Component4) {
	_inherits(FeedbackPageNegative1, _Component4);

	function FeedbackPageNegative1(props) {
		_classCallCheck(this, FeedbackPageNegative1);

		var _this8 = _possibleConstructorReturn(this, (FeedbackPageNegative1.__proto__ || Object.getPrototypeOf(FeedbackPageNegative1)).call(this, props));

		_this8.state = { locations: null };
		return _this8;
	}

	_createClass(FeedbackPageNegative1, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this9 = this;

			GetLocationList().then(function (data) {
				_this9.setState({ locations: data });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this10 = this;

			return _react2.default.createElement(
				ModalPage,
				null,
				_react2.default.createElement(
					Title,
					null,
					'Feedback'
				),
				_react2.default.createElement(
					Header,
					null,
					'We are sorry to hear that...'
				),
				_react2.default.createElement(
					Text,
					null,
					'Select a location below to let us know what happened:'
				),
				_react2.default.createElement(
					Buttons,
					null,
					(this.state.locations || []).map(function (location) {
						return _react2.default.createElement(
							Button,
							{ key: location.id, onClick: function onClick() {
									return _this10.props.setLocation(location);
								} },
							location.name
						);
					})
				)
			);
		}
	}], [{
		key: 'canGoToNextPage',
		value: function canGoToNextPage(props) {
			return !!props.location;
		}
	}]);

	return FeedbackPageNegative1;
}(_react.Component);

var FeedbackPageNegative2 = function (_Component5) {
	_inherits(FeedbackPageNegative2, _Component5);

	function FeedbackPageNegative2() {
		_classCallCheck(this, FeedbackPageNegative2);

		return _possibleConstructorReturn(this, (FeedbackPageNegative2.__proto__ || Object.getPrototypeOf(FeedbackPageNegative2)).apply(this, arguments));
	}

	_createClass(FeedbackPageNegative2, [{
		key: 'render',
		value: function render() {
			var _this12 = this;

			if (this.props.sending) {
				return _react2.default.createElement(
					ModalPage,
					null,
					_react2.default.createElement('img', { src: '/admin/images_shared/loading.gif' })
				);
			}
			return _react2.default.createElement(
				ModalPage,
				null,
				_react2.default.createElement(
					Title,
					null,
					'Feedback'
				),
				_react2.default.createElement(
					Header,
					null,
					'We are sorry to hear that...'
				),
				_react2.default.createElement(
					Text,
					null,
					'Please let us know what we can do better at our ',
					this.props.location.name,
					' location on your next visit.'
				),
				_react2.default.createElement(_textarea2.default, { label: 'Comments', rows: +Infinity, value: this.props.comment, setValue: this.props.setComment }),
				_react2.default.createElement(Checkbox, { label: 'I would like to be contacted', value: this.props.contact, setValue: this.props.setContact }),
				this.props.contact ? _react2.default.createElement(_text2.default, { label: 'Name', value: this.props.name, setValue: this.props.setName }) : null,
				this.props.contact ? _react2.default.createElement(_text2.default, { label: 'Email address', value: this.props.email, setValue: this.props.setEmail }) : null,
				this.props.contact ? _react2.default.createElement(_text2.default, { label: 'Phone number', value: this.props.phone, setValue: this.props.setPhone }) : null,
				_react2.default.createElement(
					Button,
					{ className: 'send',
						disabled: !(this.props.location && this.props.comment),
						onClick: function onClick() {
							return _this12.props.send();
						}
					},
					'Send'
				)
			);
		}
	}], [{
		key: 'canGoToNextPage',
		value: function canGoToNextPage(props) {
			return props.sent;
		}
	}]);

	return FeedbackPageNegative2;
}(_react.Component);

var FeedbackPageNegative3 = function (_Component6) {
	_inherits(FeedbackPageNegative3, _Component6);

	function FeedbackPageNegative3() {
		_classCallCheck(this, FeedbackPageNegative3);

		return _possibleConstructorReturn(this, (FeedbackPageNegative3.__proto__ || Object.getPrototypeOf(FeedbackPageNegative3)).apply(this, arguments));
	}

	_createClass(FeedbackPageNegative3, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				ModalPage,
				null,
				_react2.default.createElement(
					Title,
					null,
					'Feedback'
				),
				_react2.default.createElement(
					Header,
					null,
					'Thank you for your submission'
				),
				_react2.default.createElement(
					Button,
					{ className: 'close-button', onClick: this.props.close },
					'Close'
				)
			);
		}
	}], [{
		key: 'canGoToNextPage',
		value: function canGoToNextPage(props) {
			return false;
		}
	}]);

	return FeedbackPageNegative3;
}(_react.Component);

var FeedbackModal = function (_Modal) {
	_inherits(FeedbackModal, _Modal);

	_createClass(FeedbackModal, null, [{
		key: 'show',
		value: function show(positive) {
			this.showModal(_react2.default.createElement(FeedbackModal, { mode: positive ? 'positive' : 'negative' }));
		}
	}]);

	function FeedbackModal(props) {
		_classCallCheck(this, FeedbackModal);

		var _this14 = _possibleConstructorReturn(this, (FeedbackModal.__proto__ || Object.getPrototypeOf(FeedbackModal)).call(this, props));

		_this14.state = Object.assign(_this14.state || {}, {
			page: 0,
			pages: props.mode == "positive" ? [FeedbackPagePositive1, FeedbackPagePositive2] : [FeedbackPageNegative1, FeedbackPageNegative2, FeedbackPageNegative3],
			location: null,
			comment: "",
			contact: false,
			name: "",
			email: "",
			phone: "",
			sending: false,
			sent: false
		});
		_this14.send = _this14.send.bind(_this14);
		return _this14;
	}

	_createClass(FeedbackModal, [{
		key: 'getPageProps',
		value: function getPageProps() {
			var _this15 = this;

			var PageProps = {
				location: this.state.location,
				comment: this.state.comment,
				contact: this.state.contact,
				setLocation: function setLocation(location) {
					return _this15.setState({ location: location });
				},
				setComment: function setComment(comment) {
					return _this15.setState({ comment: comment });
				},
				setContact: function setContact(contact) {
					return _this15.setState({ contact: contact });
				},
				phone: this.state.phone,
				setPhone: function setPhone(phone) {
					return _this15.setState({ phone: phone });
				},
				email: this.state.email,
				setEmail: function setEmail(email) {
					return _this15.setState({ email: email });
				},
				sending: this.state.sending,
				sent: this.state.sent,
				send: this.send,
				close: this.close,
				name: this.state.name,
				setName: function setName(name) {
					return _this15.setState({ name: name });
				}
			};
			return PageProps;
		}
	}, {
		key: 'getPage',
		value: function getPage() {
			return this.state.pages[this.state.page];
		}
	}, {
		key: 'nextPage',
		value: function nextPage() {
			this.setState(function (state) {
				return { page: state.page + 1 };
			});
		}
	}, {
		key: 'diffObject',
		value: function diffObject(left, right) {
			var tgt = {};
			Object.keys(left).forEach(function (k) {
				if (right[k] !== left[k]) {
					tgt[k] = { original: left[k], target: right[k] };
				}
			});
			Object.keys(right).filter(function (k) {
				return !left.hasOwnProperty(k);
			}).forEach(function (k) {
				tgt[k] = { original: void 0, target: right[k] };
			});
			return tgt;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (_get(FeedbackModal.prototype.__proto__ || Object.getPrototypeOf(FeedbackModal.prototype), 'componentDidUpdate', this)) {
				_get(FeedbackModal.prototype.__proto__ || Object.getPrototypeOf(FeedbackModal.prototype), 'componentDidUpdate', this).call(this, prevProps, prevState);
			}

			var d = this.diffObject(prevState, this.state);
			if (!Object.keys(d).length) return;

			console.log(this.diffObject(prevState, this.state));

			var thePage = this.getPage();
			if (thePage.canGoToNextPage(this.getPageProps())) this.nextPage();

			if (prevState.sending != this.state.sending && this.state.sending) {
				this.doSend();
			}
		}
	}, {
		key: 'getClass',
		value: function getClass() {
			return this.props.mode == "positive" ? "pos-feedback-modal" : "neg-feedback-modal";
		}
	}, {
		key: 'send',
		value: function send() {
			if (!this.state.comment || this.state.contact && !(this.state.phone || this.state.email)) {
				return;
			}
			this.setState({ sending: true });
		}
	}, {
		key: 'doSend',
		value: function doSend() {
			var _this16 = this;

			var xhr = new XMLHttpRequest();
			xhr.open('POST', 'data/feedback', true);
			xhr.onreadystatechange = function () {
				if (xhr.readyState == 4) {
					_this16.setState({ sent: true });
				}
			};
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.send(JSON.stringify({
				comment: this.state.comment,
				contact: this.state.contact,
				name: this.state.name,
				phone: this.state.phone,
				email: this.state.email,
				location: this.state.location.id
			}));
		}
	}, {
		key: 'classList',
		get: function get() {
			return _get(FeedbackModal.prototype.__proto__ || Object.getPrototypeOf(FeedbackModal.prototype), 'classList', this).concat(this.getClass());
		}
	}, {
		key: 'content',
		get: function get() {
			var Page = this.getPage(),
			    PageProps = this.getPageProps();
			return _react2.default.createElement(Page, PageProps);
		}
	}]);

	return FeedbackModal;
}(_modal2.default);

exports.default = FeedbackModal;